import React, { useContext, useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { makeSpotifyRequest, makeSpotifyAuthRequest } from '../../config/SpotifyRequests'

import { setAuth } from '../../actions/index'
import { Loader } from '../../components/loader/Loader'

const AuthContext = React.createContext()

export function useSpotify(){
    return useContext(AuthContext)
}


function SpotifyContextContainer(props) {
    const [ code, setCode ] = useState(props.user.data ? props.user.data.code : null)
    const [ accessToken, setAccessToken ] = useState(props.user.data ? props.user.data.accessToken: null)
    const [ refreshToken, setRefreshToken ] = useState(props.user.data ? props.user.data.refreshToken: null)

    const [ user, setUser ] = useState(null)
    const [ render, setRender ] = useState(false)


    const values = {
        code,
        accessToken,
        refreshToken,
        user,
        retrievedInfo,
    }

    function retrievedInfo(code, at, rt){
        setCode(code)
        setAccessToken(at)
        setRefreshToken(rt)
        props.dispatch(setAuth(code, at, rt))
    }

    //Check for access token validity by requesting user
    useEffect(async () => {
        if(accessToken && refreshToken && code && !user){
           try{
            const res = await makeSpotifyRequest(`https://api.spotify.com/v1/me`, accessToken);

            setUser(res.data)
            setRender(true)
        }catch(e){
        
            // if(e.response.data.error.status === 401){ //Token has expired
                try {
                //get refreshedaccess token from spotify api
                const data = {
                    grant_type: "refresh_token",
                    refresh_token: refreshToken
                }
                const res = await makeSpotifyAuthRequest(data);
                const resU = await makeSpotifyRequest(`https://api.spotify.com/v1/me`, res.data.access_token);


                setAccessToken(res.data.access_token)
                setUser(resU.data)

                retrievedInfo(code, res.data.access_token, refreshToken)
                setRender(true)
                }catch(e){
                    retrievedInfo(null, null, null)
                    setRender(true)
                }
           }
        }else {
            setRender(true)
        }
    }, [accessToken, refreshToken, code])

    return (
       <>
            {((!accessToken && !code && !refreshToken) ||  (user)) &&  
                <AuthContext.Provider value={values}>
                    {props.children}
                </AuthContext.Provider>
                }
            {/* {
                (accessToken && code && refreshToken && !user) ?
                <h2>loading</h2> : null
            } */}
       </>
    )
}

function mapStateToProps(state){
    return {
        user: state.auth
    }
}

export default connect(mapStateToProps)(SpotifyContextContainer);